import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { IRouterQuery } from '../interfaces/news';

import { useOrganizations } from './organizations';

export const useOrganizationInfoFromQuery = () => {
  const organizations = useOrganizations();
  const { query } = useRouter() as TRouter<IRouterQuery>;

  const { organizationId, organizationAlias } = query;

  const organization = useMemo(() => {
    if (!organizationId && !organizationAlias) return null;

    return Object.values(organizations).find((item) => item.id === organizationId || item.alias === organizationAlias);
  }, [organizations, organizationAlias, organizationId]);

  return organization;
};
